import { render, staticRenderFns } from "./modalAddProduct.vue?vue&type=template&id=03307bf3"
import script from "./modalAddProduct.vue?vue&type=script&lang=js"
export * from "./modalAddProduct.vue?vue&type=script&lang=js"
import style0 from "./modalAddProduct.vue?vue&type=style&index=0&id=03307bf3&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03307bf3')) {
      api.createRecord('03307bf3', component.options)
    } else {
      api.reload('03307bf3', component.options)
    }
    module.hot.accept("./modalAddProduct.vue?vue&type=template&id=03307bf3", function () {
      api.rerender('03307bf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/stock/components/modalAddProduct.vue"
export default component.exports